import mixins from '@/pages/im/mixins/message'
import http from '@/util/request'
import { request, crmRequest } from '@meta-vue/util'
import ConversationModel from '@/pages/im/model/ConversationModel'
import { createCmdMsg } from '@/pages/im/utils'
import Cookies from 'js-cookie'

// 左侧用户列表手机号解密方法
async function getRealValue(data) {
  return data
}

/**
 * 获取会话中列表
 */
export const getUserList = async ({ commit, rootState }, { telephone, orderType, init, workbenchId }) => {
  if (init) commit('setUserListLoading', true)
  try {
    const conversations = await crmRequest(
      '/qmove-crm-admin/customerService/im/conversation/queryOnlineConversations',
      {
        method: 'post',

        data: {
          conversationStatus: [30], // 会话中
          channelCode: workbenchId
        }
      }
    )
    if (!Array.isArray(conversations)) {
      // 会话列表为空的时候 初始化数据
      commit('setConversationId', '')
      commit('setUserList', [])
      commit('setUserListLoadSuccess', true)
      return
    }
    conversations.forEach(v => {
      const $conversationModal = new ConversationModel(v)
      v.lastImMessageDTO = v.lastImMessageDTO
        ? v.lastImMessageDTO.filter(msg => !(msg.base.type === 'card' && msg.base.content.type == 'notify'))
        : []
      const { endConversationTime, evaluateTime, status, serviceUserId: fromUid, userId: toUid } = v
      const content = createCmdMsg({
        fromUid,
        toUid,
        endConversationTime,
        evaluateTime,
        status,
        workingObj: rootState.im.workingObj
      })
      v.lastImMessageDTO.push(...content)
      v.draftContent = $conversationModal.getDraftContent()
      v._init = true
    })
    const list = await getRealValue(conversations)
    commit('setUserList', list)
    commit('setUserListLoadSuccess', true)
  } catch (e) {
    console.error(e)
  } finally {
    commit('setUserListLoading', false)
  }
}
/**
 * 获取历史会话
 */
export const getHistory = async ({ commit, rootState }, { keyword, page = 1 } = {}) => {
  return await crmRequest({
    url: '/qmove-crm-admin/customerService/im/conversation/queryOnlineConversationsByPage',
    method: 'post',
    data: {
      pageNum: page,
      pageSize: 20,
      conversationStatus: [40],
      channelCode: window.workbenchId
    }
  }).then(async data => {
    console.log(data, 'datadatadata12222222____')
    if (!data.list?.length) return
    data.list.forEach(v => {
      const $conversationModal = new ConversationModel(v)
      v.lastImMessageDTO = !Array.isArray(v.lastImMessageDTO)
        ? []
        : v.lastImMessageDTO.filter(msg => !(msg.base.type == 'card' && msg.base.content.type == 'notify'))
      v.draftContent = $conversationModal.getDraftContent()
    })
    const historyList = { data: [] }
    historyList.page = page
    const list = data.list
    historyList.data = rootState.im.historyList.data.concat(list)
    historyList.total = data.total || 0
    historyList.loading = false
    if (data.list.length < 20) {
      historyList.end = true
    }
    commit('setHistoryList', historyList)
  })
}

/**
 * 查询回访单列表
 * @param commit
 * @param data
 * @returns {Promise<void>}
 */
export const getFollowUpList = async ({ commit, rootState }, data) => {
  // commit('setUserListLoading', true)
  // try {
  //   let conversations = await request(
  //     '/crm-online-service-app/onlineCustomerService/conversationManage/followUp/list',
  //     {
  //       method: 'post',
  //       data: { workbenchId: data.workbenchId },
  //       getter: {
  //         data: 'conversations'
  //       }
  //     }
  //   )
  //   if (!Array.isArray(conversations)) return
  //   conversations = _.differenceBy(conversations, rootState.im.userList, 'conversationId')
  //   conversations.forEach(v => {
  //     const session = new ConversationModel(v)
  //     v.lastImMessageDTO = v.lastImMessageDTO
  //       ? v.lastImMessageDTO.filter(msg => !(msg.base.type === 'card' && msg.base.content.type === 'notify'))
  //       : []
  //     const { endConversationTime, evaluateTime, status, serviceUserId: fromUid, userId: toUid } = v
  //     const content = createCmdMsg({
  //       fromUid,
  //       toUid,
  //       endConversationTime,
  //       evaluateTime,
  //       status,
  //       workingObj: rootState.im.workingObj
  //     })
  //     v.lastImMessageDTO.push(...content)
  //     v.draftContent = session.getDraftContent()
  //     v._init = true
  //   })
  //   const list = await getRealValue(conversations)
  //   // 将回访数据合并到主会话列表，只维护一份数据，维护方便
  //   commit('setUserList', rootState.im.userList.concat(list))
  // } catch (e) {
  //   console.error(e)
  // } finally {
  //   commit('setUserListLoading', false)
  // }
}

// 获取常用语
export const myCommonSentenceQuery = async (
  { commit, rootState },
  data = { content: '', pageId: '', pageSize: '' }
) => {
  return await request('/crm-online-service-app/myCommonSentence/query', {
    method: 'post',
    networkFirst: 'h5newcallcenter_im_myCommonSentence',
    data: {
      ...data,
      workbenchId: rootState.app.imWorkBenchId
    }
  })
}
// 删除常用语
export const myCommonSentenceDelete = async ({ commit }, id) => {
  const res = await http({
    url: '/crm-online-service-app/myCommonSentence/del',
    method: 'get',
    params: {
      id: id
    }
  })
  return res.data
}
export const setConversationId = ({ commit }, data) => {
  commit('setConversationId', data)
}
export const setUserList = ({ commit, state }, data) => {
  // 如果匹配当前会话，需要更新currentService
  const imService = _.find(state.userList, ['conversationId', state.currentService?.conversationId])
  if (imService) {
    commit('setCurrentService', Object.assign(state.currentService || {}, imService))
  }
  commit('setUserList', data)
}
// 更新会话数据对象
export const setUserListByCallId = ({ commit, state }, { conversationId, ...extend }) => {
  // 兼容热线im场景，无会话列表，先更新
  if (state.currentService?.conversationId === conversationId) {
    commit('setCurrentService', Object.assign(state.currentService, extend))
  }
  // 如果是在线im场景，需要更新会话列表
  const index = _.findIndex(state.userList, ['conversationId', conversationId])
  if (index === -1) return
  state.userList[index] = Object.assign(state.userList[index], extend)
  commit('setUserList', state.userList)
}
export const setHistoryList = ({ commit }, data) => {
  commit('setHistoryList', data)
}
export const setShortcutSearchKeywords = ({ commit }, data) => {
  commit('setShortcutSearchKeywords', data)
}
export const setCurrentService = async ({ commit }, data) => {
  commit('setCurrentService', data)
}

// 获取工作台配置
export const getOnlineWorkbenchInfo = async ({ commit, rootState }) => {
  try {
    const res = await request({
      url: 'crm-online-service-app/onlineCustomerService/serviceUser/getOnlineWorkbenchInfo',
      method: 'post',
      networkFirst: 'h5newcallcenter_getOnlineWorkbenchInfo',
      data: {
        workbenchId: rootState.app.imWorkBenchId
      },
      getter: {
        data: null,
        code: 'result',
        message: 'errorMsg'
      }
    })
    let pollingInterval = 6000
    // try {
    // const second = await request('/crm-online-service-app/onlineCustomerService/setting/queryConfigValue', {
    //   method: 'get',
    //   params: {
    //     workbenchId: rootState.app.imWorkBenchId
    //   }
    // })
    // pollingInterval = 6000
    // } catch (e) {
    //   console.warn(e)
    // }
    const { workbenchId } = res || {}
    window.workbenchId = workbenchId
    Cookies.set('workbenchId', workbenchId)
    commit('setWorkingObj', { ...res, id: workbenchId, pollingInterval })
  } catch (e) {
    console.warn(e)
  }
}
/**
 * 安全的更新当前会话数据操作，防止错位更新
 * @param commit
 * @param state
 * @param data
 */
export const updateCurrentService = ({ commit, state }, data) => {
  if (data.conversationId != state.currentService?.conversationId) return
  commit('setCurrentService', Object.assign(state.currentService, data))
}
export const clearCurrentService = async ({ commit }, data) => {
  commit('clearCurrentService', data)
}
export const setIsHistory = ({ commit }, data) => {
  commit('setIsHistory', data)
}
export const setInvited = ({ commit }, data) => {
  commit('setInvited', data)
}
export const setWorkingObj = ({ commit }, data) => {
  commit('setWorkingObj', data)
}
export const setImExpiryStatus = ({ commit }, data) => {
  commit('setImExpiryStatus', data)
}
export const setAudioList = ({ commit }, data) => {
  commit('setAudioList', data)
}
export const pushAudioList = ({ commit }, data) => {
  commit('pushAudioList', data)
}
